import { Settings2 } from 'lucide-react';
import { useContext } from 'react';
import Chip from '@/common/Chip';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext from '~/context/common/FacetDataContext';
import ModalContext from '~/context/srp/ModalContext/ModalContext';
import useGetFilterTags from '~/hooks/common/searches/useGetFilterTags';

export default function MobileFiltersCta() {
  const { baseline } = useContext(FacetDataContext);
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const filterTags = useGetFilterTags(baseline, appliedFilters, {
    includeVehicleAlerts: true
  });
  const { setFilterModalOpen } = useContext(ModalContext);

  const numberOfTags = filterTags.length;

  return (
    <Chip
      className="px-lg py-md"
      data-adobe-id="filter-menu"
      data-analytics-id="Filter Menu"
      data-analytics-attributes={JSON.stringify({
        item: 'open modal button'
      })}
      data-testid="open-filter-modal"
      testId="open-filter-modal"
      onClick={() => setFilterModalOpen(true)}
    >
      <Settings2 size={16} />
      {numberOfTags > 0 && <span>({numberOfTags.toLocaleString()})</span>}
    </Chip>
  );
}
